import React from "react";
import { Button, Form } from "react-bootstrap";
import StatusFilter from "./StatusFilter";
import SearchFilter from "./SearchFilter";
import GoogleAutocomplete from "./GoogleAutoComplete";
import { useTranslation } from "react-i18next";

const Filter = ({
  statusFilterOptionArr,
  setBody,
  body,

  searchHandler,
  setBodyFilter,
  FilterRegion,
  type,
}) => {
  const { t } = useTranslation();
  const clearFilters = (e) => {
    setBody({
      ...body,
      status: e.target.value,
      search: "",
      eventType: "",
    });

    if ((searchHandler, setBodyFilter)) {
      searchHandler("");
      setBodyFilter("");
    }
  };

  return (
    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-end gap-10 flex-wrap">
      {statusFilterOptionArr && (
        <>
          <li className="d-flex align-items-center gap-10 flex-column">
            <label
              htmlFor=""
              className="form-label m-0 fw-sbold text-muted"
              style={{ whiteSpace: "nowrap" }}
            >
              {t("labels.filterbyStatus")}
            </label>
            <StatusFilter
              body={body}
              setBody={setBody}
              statusFilterOptionArr={statusFilterOptionArr}
            />
          </li>
        </>
      )}

      {searchHandler &&
        <li className="">
          <SearchFilter
            body={body}
            setBody={setBody}
            searchHandler={searchHandler}
          />
        </li>
      }
      <li className="ml-2">
        <Button variant="secondary" onClick={clearFilters}>
          Clear
        </Button>
      </li>
    </ul>
  );
};

export default Filter;
